import React from "react"

export default function HeaderMenuDumpster({ isMenuOpen, toggleMenu }) {

  return (
    <div
      className="collapse navbar-collapse justify-content-end"
      id="navbarSupportedContent"
    >
      <div className={`mobile-content ${isMenuOpen ? "show" : ""}`}>
        <div className="mobile-header">
          <button
            type="button"
            className="modal-closer"
            onClick={toggleMenu}
            aria-label="Close"
          >
            <span>X</span>
          </button>
        </div>
        <ul className="navbar-nav dumpster">
          <li class="nav-item dumpster">
            <a class="nav-link" href="#" onClick={() => window.location.href = "/book"}>
              Book a Dumpster
            </a>
          </li>
          <li class="nav-item dumpster">
            <a class="nav-link" href="/dumpster-rental">
              Find Dumpster Services
            </a>
          </li>
          <li class="nav-item dumpster">
            <a class="nav-link" href="/junk-removal">
              Find Junk Removal Services
            </a>
          </li>
          <li class="nav-item dumpster">
            <a class="nav-link" href="/commercial-waste-management">
              Find Commercial Waste Services
            </a>
          </li>
          <li class="nav-item dumpster">
            <a class="nav-link" href="/blog">
              Waste Removal Tips & Advice
            </a>
          </li>
          <li class="nav-item dumpster">
            <a class="nav-link" href="/pro/guide/dumpster-marketing">
              Join as a Pro
            </a>
          </li>
        </ul>
      </div>

      {!isMenuOpen && (
        <ul className="navbar-nav dumpster-desktop">
          <li class="nav-item">
            <a class="nav-link" href="/book">
              Book a Dumpster
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/junk-removal">
              Junk Removal
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/commercial-waste-management">
              Commercial Waste
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/blog">
              Blog
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/pro/guide/dumpster-marketing">
              Join as a Pro
            </a>
          </li>
        </ul>
      )}
    </div>
  )
}
